export default {
  root: 'embedded-component',
};
